<div class="page-section">
    <div class="page-section-header">
        <h2 class="page-section-title">Deposit ({{status == 2 ? 'Pending Approval' : status == 1 ? 'Approved' : 'Rejected'}})</h2>
    </div>
    <div class="page-section-filters">
        <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 2" (click)="getDeposits(2)">Pending</button>
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 1" (click)="getDeposits(1)">Approved</button>
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 0" (click)="getDeposits(0)">Rejected</button>
        </div>
    </div>
    <div class="page-section-body">
        <table class="table">
            <thead>
                <tr>
                    <th>No</th>
                    <th>Player</th>
                    <th>Amount</th>
                    <th>Image</th>
                    <th *ngIf="status == 2">Status</th>
                    <th *ngIf="status == 2">Bank</th>
                    <th *ngIf="status == 2">Action</th>
                    <th *ngIf="status == 2">Action</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let deposit of deposits; let i = index">
                    <td>{{i+1}}</td>
                    <td>{{deposit.player}} <span *ngIf="deposit.is_suspended == 1" class="badge bg-danger">Suspended</span></td>
                    <td><input type="text" class="form-control form-control-sm" [(ngModel)]="deposit.amount"></td>
                    <td>
                        <img [src]="'/storage' + deposit.file" alt="Image" class="img-fluid" style="max-width: 100px; border-radius: 4px; cursor: pointer;" (click)="openImagePopup('/storage' + deposit.file)">
                    </td>
                    <td *ngIf="status == 2">
                        <select class="form-select form-select-sm" [(ngModel)]="deposit.status">
                            <option [value]="1" selected>Approved</option>
                            <option [value]="0">Rejected</option>
                        </select>
                    </td>
                    <td *ngIf="status == 2">
                        <select class="form-select form-select-sm" [(ngModel)]="deposit.bank_id">
                            <option *ngFor="let bank of banks" [value]="bank.id">{{bank.title}} - {{bank.payee}} - {{bank.account}}</option>
                        </select>
                    </td>
                    <td *ngIf="status == 2">
                        <a class="btn btn-outline-primary btn-sm" [routerLink]="['/lo', company_uuid, 'wallet-topup-withdraw']" [queryParams]="{player: deposit.player_uuid}">View</a>
                    </td>
                    <td *ngIf="status == 2">
                        <button class="btn btn-primary btn-sm" [disabled]="deposit.is_suspended == 1" (click)="updateDeposit(deposit)">UPDATE</button>
                    </td>
                    <td>{{deposit.create_on | date:'dd/MM/yyyy HH:mm'}}</td>
                </tr>
                <tr *ngIf="deposits.length == 0 && !is_loading">
                    <td colspan="100%" class="text-center text-muted py-4" style="font-style: italic;">No data found</td>
                </tr>
                <tr *ngIf="is_loading">
                    <td colspan="100%" class="text-center text-muted py-4" style="font-style: italic;">Loading...</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="page-section-footer" *ngIf="!is_loading && deposits.length > 0">
        <span>Total Deposits:</span>
        <span class="page-section-stat">{{deposits.length}}</span>
    </div>
</div>
